// 펫 기분(mood): pet_agg_vital.mood_meter(0~mood_max) 수치를 ssot.PET_MOOD_MAP 버킷으로 변환.
// PET_MOOD_MAP 예: [{min:80,id:'EXCITED',icon:'🤩',label:'신남'}, ... {min:0,id:'GLOOMY',...}]
// 규칙: 0~100%로 정규화 후 min 내림차순으로 pct >= min 인 첫 버킷 선택.

// mood_meter/max + 버킷맵 → { id, label, emoji }. 맵 없거나 빈 값이면 ❔ 폴백.
export function resolveMood(moodMeter, moodMax, moodMap) {
  const pct = moodMax > 0 ? Math.round((moodMeter / moodMax) * 100) : 0;
  const buckets = Array.isArray(moodMap) ? [...moodMap].sort((a, b) => b.min - a.min) : [];
  const found = buckets.find((b) => pct >= b.min) || buckets[buckets.length - 1];
  return found
    ? { id: found.id, label: found.label, emoji: found.icon }
    : { id: null, label: "상태 없음", emoji: "❔" };
}
